import { type InputHTMLAttributes } from 'react';
import { type FieldError, type Control, type FieldPath, type FieldValues, useController } from 'react-hook-form';
import FileInput, { type FileInputProps } from '../file-input';
import './ControlledFileInput.css';

type FileInputValue = File | { id: number; url: string };

export interface ControlledFileInputProps<TFieldValues extends FieldValues = FieldValues> extends Omit<FileInputProps, 'error' | 'value' | 'onChange' | 'onBlur'>, Omit<InputHTMLAttributes<HTMLInputElement>, 'className' | 'onChange' | 'value' | 'multiple'> {
    name: FieldPath<TFieldValues>;
    control: Control<TFieldValues>;
    error?: FieldError | any;
}

export default function ControlledFileInput<TFieldValues extends FieldValues = FieldValues>({
    name,
    control,
    error: errorProp,
    className = '',
    ...props
}: ControlledFileInputProps<TFieldValues>) {
    // Используем useController для работы с формой
    const { field, fieldState } = useController({
        control,
        name,
    });

    const error = fieldState.error || errorProp;

    const handleChange = (files: FileInputValue | FileInputValue[] | null) => {
        field.onChange(files);
    };

    const handleBlur = () => {
        field.onBlur();
    };

    return (
        <div className="controlled-file-input-wrapper">
            <FileInput
                className={className}
                value={field.value || null}
                onChange={handleChange}
                onBlur={handleBlur}
                error={error ? error.message : undefined}
                {...props}
            />
        </div>
    );
}

